import React from 'react';
import PropTypes from 'prop-types';
import Cookies from 'js-cookie';
import { throttle } from 'lodash';

import * as Icons from './../sharedComponents/icons/Icons';

const propTypes = {
    image: PropTypes.shape({
        backgroundImage: PropTypes.string
    }),
    title: PropTypes.string,
    children: PropTypes.node,
    sticky: PropTypes.bool,
    textColor: PropTypes.string,
    background: PropTypes.string,
    name: PropTypes.string,
    closedAnnouncement: PropTypes.func
};

export default class Announcement extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showAnnouncement: false,
            visibility: false
        };

        this.toggleVisibility = this.toggleVisibility.bind(this);
        this.closeAnnouncement = this.closeAnnouncement.bind(this);
        this.handleWindowResize = throttle(this.handleWindowResize.bind(this), 50);
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleWindowResize);
        this.handleWindowResize();

        if (!Cookies.get(this.props.name)) {
            // Cookie does not exist, show the announcement
            this.setState({
                showAnnouncement: true
            });
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowResize);
    }

    setMobileHeaderRef = (node) => {
        this.mobileHeader = node;
    };

    setPlaceholderRef = (node) => {
        this.placeholder = node;
    };

    closeAnnouncement() {
        this.setState({
            showAnnouncement: false
        }, () => {
            this.props.closedAnnouncement(this.props.name);
            document.body.classList.remove('rec-announcement-no-body-scroll');
        });
    }

    generatetextColorClass(textColor) {
        switch (textColor) {
            case 'dark':
                return 'rec-announcement-text-dark';
            case 'light':
                return 'rec-announcement-text-light';
            default:
                return '';
        }
    }

    generatebackgroundClass(background) {
        switch (background) {
            case 'dark':
                return 'rec-announcement-content-bg-dark';
            case 'light':
                return 'rec-announcement-content-bg-light';
            default:
                return '';
        }
    }

    toggleVisibility() {
        this.setState((prevState) => {
            return {
                visibility: !prevState.visibility
            };
        });
    }

    handleWindowResize() {
        const windowWidth = window.innerWidth;

        // Set the size of the placeholder so mobile banner header doesn't
        // overlap the footer
        if (this.mobileHeader) {
            this.placeholder.style.height = `${this.mobileHeader.clientHeight}px`;
        }

        if (this.state.windowWidth !== windowWidth) {
            this.setState({
                windowWidth
            });
        }

        if (windowWidth > 768) {
            this.setState({
                visibility: true
            });
        }
    }

    render() {
        if (!this.state.showAnnouncement) {
            return null;
        }

        let stickyClass = 'rec-announcement-sticky';
        if (!this.props.sticky) {
            stickyClass = '';
        }

        let showAnnouncementClass = "rec-announcement-sticky-body-shown";
        if (!this.state.visibility) {
            showAnnouncementClass = "rec-announcement-sticky-body-hidden";
        }

        // Prevent <body> scrolling if the announcement is open and the viewport is under 768px
        if (this.state.windowWidth < 768 && this.state.visibility) {
            document.body.classList.add('rec-announcement-no-body-scroll');
        }
        else {
            document.body.classList.remove('rec-announcement-no-body-scroll');
        }

        const textColorClass = this.generatetextColorClass(this.props.textColor);
        const backgroundClass = this.generatebackgroundClass(this.props.background);

        return (
            <React.Fragment>
                <div data-name="placeholder" ref={this.setPlaceholderRef} />
                <div className={`rec-announcement ${textColorClass} ${stickyClass} ${showAnnouncementClass}`} style={this.props.image}>
                    <div ref={this.setMobileHeaderRef} className="rec-announcement-mobile-header">
                        <button
                            onClick={this.toggleVisibility}
                            className="rec-announcement-toggle"
                            aria-label="Toggle Announcement"
                            type="button">
                            {this.state.visibility ? <Icons.IconChevronDown alt="Hide Announcement" /> : <Icons.IconChevronUp alt="Show Announcement" />}
                        </button>
                        <div className="rec-announcement-mobile-title">
                            {this.props.title}
                        </div>
                    </div>
                    <button
                        className="rec-button-link rec-announcement-close"
                        onClick={this.closeAnnouncement}
                        aria-label="Dismiss Announcement"
                        type="button">
                        <Icons.IconClose />
                    </button>

                    {this.state.visibility && (
                        <div className={`rec-announcement-content ${backgroundClass}`}>
                            <div className="rec-announcement-title">{this.props.title}</div>
                            <div className="rec-announcement-description">
                                {this.props.children}
                            </div>

                            <button
                                className="rec-announcement-close-mobile"
                                onClick={this.closeAnnouncement}
                                aria-label="Close Announcement"
                                type="button">
                                Close Announcement
                            </button>
                        </div>
                    )}
                </div>
            </React.Fragment>
        );
    }
}

Announcement.propTypes = propTypes;
